'use client'

//__IMPORTS
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import { useEffect } from 'react'

//__COMPONENTS
import { ButtonBooking } from '@/components/home/btn-book'
import { OrganizationJsonLd } from '@/components/home/OrganizationJsonLd'

import CityContainer from './components/cityContainer'
import { useDestination } from './context/DestinationContext'
//__TYPES
import { IBranch } from './types/schema'

//__STYLES
import '@/styles/pages/destination.scss'

const BookingFormComponent = dynamic(
  () => import('@/components/forms/booking').then((mod) => mod.BookingFormComponent),
  { ssr: false, loading: () => <div className='booking-form-placeholder'></div> }
)

export default function Page() {
  //__GET DATA FROM CONTEXT
  const { data, isMobile } = useDestination()
  const t = useTranslations()

  useEffect(() => {
    if (data?.branches?.length && typeof performance !== 'undefined') {
      performance.mark('cities-rendered')
    }
  }, [data?.branches])

  return (
    <div className='ui--location'>
      <section className='ui--location-section'>
        <>
          {isMobile ? (
            <div className='ui--location-booking-btn'>
              <ButtonBooking />
            </div>
          ) : (
            <BookingFormComponent />
          )}
        </>
        <div className='content'>
          <h1>{t('Destinations.SEO_PAGE_H1')}</h1>
          <h3>{t('Index.SUB_HEADER_PAGE')}</h3>
          <div className='flex-container'>
            <div className='image-container'>
              <Image
                src='/static/images/maps/v-map.png'
                alt='Oasis Spa V Map'
                width={600}
                height={400}
                className='map-image'
                priority={true}
              />

              <div className='map-button-container'>
                <button
                  onClick={() =>
                    window.open(
                      'https://www.google.com/maps/d/u/0/edit?mid=1KkZTyT_tQZb0kMylk9YBV5pEI9ZTqpQ&usp=sharing',
                      '_blank'
                    )
                  }
                  className='map-button'>
                  <svg
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                    stroke='#254638'
                    className='map-icon hover-icon'>
                    <path
                      d='M12 6H12.01M9 20L3 17V4L5 5M9 20L15 17M9 20V14M15 17L21 20V7L19 6M15 17V14M15 6.2C15 7.96731 13.5 9.4 12 11C10.5 9.4 9 7.96731 9 6.2C9 4.43269 10.3431 3 12 3C13.6569 3 15 4.43269 15 6.2Z'
                      stroke='#254638'
                      strokeWidth={2}
                      strokeLinecap='round'
                      strokeLinejoin='round'></path>
                  </svg>
                  {t('Work US.WORK_MAP')}
                </button>
              </div>
            </div>
            <div className='city-container'>
              <h4>{t('Index.SUB_HEADER_DETAIL')}</h4>
              {data?.branches.map((city: IBranch, index: number) => (
                <CityContainer key={index} city={city} />
              ))}
            </div>
          </div>
        </div>
      </section>
      <OrganizationJsonLd
        title={t('Menu.SEO_PAGE_TITLE')}
        description={t('Menu.SEO_DESCRIPTION')}
        brandName='Oasis Spa'
      />
    </div>
  )
}
